var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwlad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.385,
    height: 96.385,
    viewBox: "0 0 96.385 96.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AWLAD",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "KALIMAT_IMAGE",
    "data-name": "KALIMAT IMAGE",
    d: "M12.851,0H83.534A12.851,12.851,0,0,1,96.385,12.851V83.534A12.851,12.851,0,0,1,83.534,96.385H12.851A12.851,12.851,0,0,1,0,83.534V12.851A12.851,12.851,0,0,1,12.851,0Z",
    fill: "#2f8495"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AWLAD_SCHOOL",
    "data-name": "AWLAD SCHOOL",
    transform: "translate(10.024 16.033) rotate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4631",
    "data-name": "Trac\\xE9 4631",
    d: "M12.059,10.8a5.75,5.75,0,0,1-1.052,1.227A8.673,8.673,0,0,1,9.675,13a8.54,8.54,0,0,1-1.542.666,5.215,5.215,0,0,1-1.648.245,6.253,6.253,0,0,1-4.171-1.437,6.075,6.075,0,0,1-1.3-1.542A7.412,7.412,0,0,1,.245,9.044,7.962,7.962,0,0,1,0,6.976,7.962,7.962,0,0,1,.28,4.908a8.938,8.938,0,0,1,.771-1.893,6.235,6.235,0,0,1,1.3-1.577A5.729,5.729,0,0,1,4.136.386,6.809,6.809,0,0,1,6.45,0,6.508,6.508,0,0,1,8.133.21a5.637,5.637,0,0,1,1.507.6,6.1,6.1,0,0,1,1.3,1.052,6.992,6.992,0,0,1,1.122,1.577L8.974,4.908a2.137,2.137,0,0,0-.456-.561,2.421,2.421,0,0,0-.7-.456,2.994,2.994,0,0,0-.841-.315,2.882,2.882,0,0,0-.946-.07,3.121,3.121,0,0,0-1.262.386,2.252,2.252,0,0,0-.876.841,4.117,4.117,0,0,0-.526,1.122A5.214,5.214,0,0,0,3.19,7.116,3.61,3.61,0,0,0,3.4,8.343a3.992,3.992,0,0,0,.561,1.087,2.951,2.951,0,0,0,.946.771,2.669,2.669,0,0,0,1.332.28,3.733,3.733,0,0,0,1.683-.421,5.021,5.021,0,0,0,.771-.526A3.188,3.188,0,0,0,9.324,8.8Z",
    transform: "translate(17.878 14.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4632",
    "data-name": "Trac\\xE9 4632",
    d: "M6.485,13.916a6.253,6.253,0,0,1-4.171-1.437,6.074,6.074,0,0,1-1.3-1.542A7.412,7.412,0,0,1,.245,9.044,7.963,7.963,0,0,1,0,6.976,7.962,7.962,0,0,1,.28,4.908a8.939,8.939,0,0,1,.771-1.893,6.236,6.236,0,0,1,1.3-1.577A5.729,5.729,0,0,1,4.136.386,6.662,6.662,0,0,1,6.45,0,6.346,6.346,0,0,1,8.658.386a4.579,4.579,0,0,1,1.683,1.052A7.664,7.664,0,0,1,11.568,2.98,7.6,7.6,0,0,1,12.3,4.837a7.878,7.878,0,0,1,.245,2.033A7.7,7.7,0,0,1,12.3,8.9a7.32,7.32,0,0,1-.736,1.893,6.683,6.683,0,0,1-1.192,1.542,5.476,5.476,0,0,1-1.683,1.052A4.375,4.375,0,0,1,6.485,13.916ZM6.029,3.54a2.8,2.8,0,0,0-1.262.351,2.774,2.774,0,0,0-.876.806,3.681,3.681,0,0,0-.526,1.122A5.214,5.214,0,0,0,3.19,7.081,3.969,3.969,0,0,0,3.4,8.343a3.542,3.542,0,0,0,.561,1.087,2.95,2.95,0,0,0,.946.771,2.669,2.669,0,0,0,1.332.28A2.653,2.653,0,0,0,8.448,9.359,3.175,3.175,0,0,0,8.974,8.2a4.1,4.1,0,0,0,.14-1.3,7.706,7.706,0,0,0-.21-1.3,3.138,3.138,0,0,0-.6-1.122,3.1,3.1,0,0,0-.982-.771A2.6,2.6,0,0,0,6.029,3.54Z",
    transform: "translate(44.133 14.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4633",
    "data-name": "Trac\\xE9 4633",
    d: "M6.485,13.916a6.253,6.253,0,0,1-4.171-1.437,6.074,6.074,0,0,1-1.3-1.542A7.412,7.412,0,0,1,.245,9.044,7.963,7.963,0,0,1,0,6.976,7.962,7.962,0,0,1,.28,4.908a8.939,8.939,0,0,1,.771-1.893,6.236,6.236,0,0,1,1.3-1.577A5.729,5.729,0,0,1,4.136.386,6.662,6.662,0,0,1,6.45,0,6.346,6.346,0,0,1,8.658.386a4.579,4.579,0,0,1,1.683,1.052A7.664,7.664,0,0,1,11.568,2.98,7.6,7.6,0,0,1,12.3,4.837a7.877,7.877,0,0,1,.245,2.033A7.7,7.7,0,0,1,12.3,8.9a7.32,7.32,0,0,1-.736,1.893,6.683,6.683,0,0,1-1.192,1.542,5.476,5.476,0,0,1-1.683,1.052A4.375,4.375,0,0,1,6.485,13.916ZM6.029,3.54a2.8,2.8,0,0,0-1.262.351,2.774,2.774,0,0,0-.876.806,3.681,3.681,0,0,0-.526,1.122A5.214,5.214,0,0,0,3.19,7.081,3.969,3.969,0,0,0,3.4,8.343a3.542,3.542,0,0,0,.561,1.087,2.951,2.951,0,0,0,.946.771,2.669,2.669,0,0,0,1.332.28A2.653,2.653,0,0,0,8.448,9.359,3.175,3.175,0,0,0,8.974,8.2a4.1,4.1,0,0,0,.14-1.3,7.7,7.7,0,0,0-.21-1.3,3.137,3.137,0,0,0-.6-1.122,3.1,3.1,0,0,0-.981-.771A2.6,2.6,0,0,0,6.029,3.54Z",
    transform: "translate(58.26 14.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4634",
    "data-name": "Trac\\xE9 4634",
    d: "M3.646,18.649H0L.07,0H3.54Z",
    transform: "translate(72.176 9.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4635",
    "data-name": "Trac\\xE9 4635",
    d: "M10.341,14.057h-2.8V8.448H2.769L2.8,14.092H0V.035H2.664L2.7,5.784H7.466V0h2.664Z",
    transform: "translate(31.513 14.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4636",
    "data-name": "Trac\\xE9 4636",
    d: "M2.559,9.535c0,2.454,1.542,3.681,4.767,3.681,2.7,0,5.4-.7,6.52-1.928A13.537,13.537,0,0,0,10.937,9.5c-2.1-1.157-3.47-1.753-3.47-3.085A6.074,6.074,0,0,1,13.671,0,4.872,4.872,0,0,1,16.58.981l-.911,2.594a4.857,4.857,0,0,0-2.243-.631A3.948,3.948,0,0,0,9.675,5.328a16.837,16.837,0,0,0,2.945,1.823c2.7,1.472,3.33,2.419,3.33,3.716a4.01,4.01,0,0,1-1.157,2.98C13.145,15.6,9.955,16.3,6.871,16.3,2.419,16.3,0,14.2,0,10.341A20.307,20.307,0,0,1,.736,5.433l2.243.351A23.52,23.52,0,0,0,2.559,9.535Z",
    transform: "translate(0 13.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8267",
    "data-name": "Trac\\xE9 8267",
    d: "M10.3.108l2.08.514q-.025.152-.117.609t-.228,1.116q-.136.659-.308,1.477t-.352,1.69q-.181.872-.368,1.75L10.655,8.93q-.168.789-.311,1.439t-.238,1.056H7.386q-.057-.165-.133-.466t-.168-.694q-.092-.393-.2-.862t-.222-.973q-.117-.5-.235-1.021T6.194,6.391q-.12.5-.241,1.021T5.719,8.436q-.114.5-.222.97t-.2.859q-.092.393-.171.691T5,11.425H2.276q-.1-.406-.238-1.056T1.728,8.933L1.373,7.272Q1.186,6.4,1,5.525T.653,3.842Q.482,3.031.346,2.371T.117,1.255Q.025.8,0,.647L2.08.133,3.728,7.944,5.186,1.211H7.2L8.654,7.919Zm5.085,9.263h3.874v2.175H13.156V.032H15.3Zm11.641-.33-3.766-.025-.881,2.733-2-.786q.038-.12.149-.46t.279-.846q.168-.507.377-1.144l.441-1.344q.231-.707.479-1.452L22.6,4.245q.241-.726.463-1.4t.409-1.23l.327-.973L24,.019,26.141,0q.089.2.244.615t.355.97q.2.558.431,1.233l.482,1.408q.25.732.5,1.484t.491,1.465q.238.713.45,1.357l.38,1.154q.168.51.282.853t.152.463l-2,.786ZM24.055,6.866l2.181.006L25.145,3.4Z",
    transform: "translate(24.946 0.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8266",
    "data-name": "Trac\\xE9 8266",
    d: "M6.645,9.041,2.878,9.016,2,11.748l-2-.786q.038-.12.149-.46t.279-.846Q.6,9.149.805,8.512l.441-1.344q.231-.707.479-1.452l.488-1.471q.241-.726.463-1.4t.409-1.23L3.411.644,3.62.019,5.757,0Q5.846.2,6,.615t.355.97q.2.558.431,1.233l.482,1.408q.25.732.5,1.484t.491,1.465q.238.713.45,1.357L9.1,9.685q.168.51.282.853T9.529,11l-2,.786ZM3.671,6.866l2.181.006L4.762,3.4Z",
    transform: "translate(16.185 0.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8265",
    "data-name": "Trac\\xE9 8265",
    d: "M7.786,5.689a5.623,5.623,0,0,1-.222,1.775,4.979,4.979,0,0,1-1.912,2.669,6.353,6.353,0,0,1-1.572.812,7.979,7.979,0,0,1-1.9.412A10.208,10.208,0,0,1,0,11.326V.059A12.322,12.322,0,0,1,2.064.03,8.3,8.3,0,0,1,3.9.367a6.216,6.216,0,0,1,1.553.716A4.781,4.781,0,0,1,6.664,2.2a5.183,5.183,0,0,1,.8,1.531A6.979,6.979,0,0,1,7.786,5.689ZM5.82,6.146a5.171,5.171,0,0,0-.187-1.487A3.511,3.511,0,0,0,4.98,3.384a3.468,3.468,0,0,0-1.186-.923A4.8,4.8,0,0,0,2.01,2.024l.044,7.564a4.8,4.8,0,0,0,1.534-.346,3.888,3.888,0,0,0,1.182-.751A3.36,3.36,0,0,0,5.535,7.43,3.21,3.21,0,0,0,5.82,6.146Z",
    transform: "translate(54.017 1.352) rotate(-10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blackboard",
    transform: "translate(29.637 52.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5086",
    "data-name": "Groupe 5086",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5085",
    "data-name": "Groupe 5085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5084",
    "data-name": "Groupe 5084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8631",
    "data-name": "Trac\\xE9 8631",
    d: "M527.461,1268.8l.959,2.058H515.9l.959-2.058Z",
    transform: "translate(-503.605 -1238.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8632",
    "data-name": "Trac\\xE9 8632",
    d: "M298.776,1077.7l-1.95,4.18-1.242,2.665a.138.138,0,0,0-.007.017l-1.865,4H290.9l5.066-10.863Z",
    transform: "translate(-284.041 -1052.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8633",
    "data-name": "Trac\\xE9 8633",
    d: "M935.91,1077.7l5.066,10.863h-2.812l-1.872-4.015-1.237-2.655-.007-.015L933.1,1077.7Z",
    transform: "translate(-910.725 -1052.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8634",
    "data-name": "Trac\\xE9 8634",
    d: "M44.111,22.7v2.636H7V22.7Z",
    transform: "translate(-7 -22.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8635",
    "data-name": "Trac\\xE9 8635",
    d: "M135.186,157v21.638H102.7V157Z",
    transform: "translate(-100.388 -153.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8636",
    "data-name": "Trac\\xE9 8636",
    d: "M893.852,646.111a1.647,1.647,0,1,1-1.626-1.911A1.788,1.788,0,0,1,893.852,646.111Z",
    transform: "translate(-869.252 -629.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8637",
    "data-name": "Trac\\xE9 8637",
    d: "M549.941,438.416H546.1l1.921-5.516Z",
    transform: "translate(-533.075 -422.989)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "\\u062A",
    d: "M0,7.384A15.161,15.161,0,0,1,.625,3.815l1.78.323a16.767,16.767,0,0,0-.3,2.335c0,2.2,1.686,2.962,5.53,2.962,4.469,0,5.644-.7,5.644-1.766a21.965,21.965,0,0,0-.455-3.379l2.216-.342a21.939,21.939,0,0,1,.322,3.322,4.116,4.116,0,0,1-.928,3.132c-1.06,1.063-3.56,1.633-7.443,1.633C1.61,12.035,0,10.4,0,7.384ZM8.088,1.553Q8.088,0,9.544,0T11,1.553a1.532,1.532,0,0,1-.4,1.111,1.453,1.453,0,0,1-1.055.4Q8.088,3.066,8.088,1.553Zm-3.66,0A1.541,1.541,0,0,1,4.855.415,1.462,1.462,0,0,1,5.937,0Q7.42,0,7.42,1.553a1.5,1.5,0,0,1-.414,1.111,1.442,1.442,0,0,1-1.069.4A1.335,1.335,0,0,1,4.428,1.553Z",
    transform: "translate(10.876 7.376)",
    fill: "#61a9b2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwlad);
export default __webpack_public_path__ + "static/media/icon-awlad.2fc94fda.svg";
export { ForwardRef as ReactComponent };